import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-medicion',
  templateUrl: './medicion.component.html',
  styleUrls: ['./medicion.component.css']
})
export class MedicionComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  async rutas () {
    this.router.navigate(["componentes/generarutas"]);
  }

  async captura() {
    this.router.navigate(["componentes/consultalecturas"]);
  }
  
}
